// Environment color configuration
const ENV_THEMES = {
  dev: { label: "DEV", color: "#3B82F6", dark: "#1E3A5F", light: "#DBEAFE" },
  stg: { label: "STG", color: "#EF4444", dark: "#7F1D1D", light: "#FEE2E2" },
  prod: { label: "PROD", color: "#49b499", dark: "#1a4a3a", light: "#d1f0e7" },
} as const;

type EnvKey = keyof typeof ENV_THEMES;

export function getEnvTheme(env: string) {
  const key = (env || "dev") as EnvKey;
  return ENV_THEMES[key] || ENV_THEMES.dev;
}

export function initEnvTheme(env: string) {
  const theme = getEnvTheme(env);
  const root = document.documentElement;
  root.style.setProperty("--env-color", theme.color);
  root.style.setProperty("--env-color-dark", theme.dark);
  root.style.setProperty("--env-color-light", theme.light);
  return theme;
}
